module.exports = __webpack_public_path__ + "img/promo-6-mock.3394ea2f.png";